import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import '../styles.less'
import { getAnnualTaxRemittance } from '../../../redux/actions/eFilling'
import AnnualTaxRemittanceWidget from '../../../widgets/eFillingListFormWidgets/AnnualTaxRemittanceWidget'

export default function AnnualTaxRemittanceApprover() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = {
        withholdingType: null,
        projectCode: '',
        taxMonth: '',
        contractNo: '',
        submitStartDate: '',
        submitEndDate: '',
        status: 1,
      }
      const response = await getAnnualTaxRemittance(request)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <AnnualTaxRemittanceWidget schema={schema.forms} />

        <br />
      </SidebarProposal>
    </div>
  )
}
